//TODO: make this a configuration somewhere else
const enabledApps = new Set(['ondemand']);

export function isCoachEnabledByApp(appName: string): boolean {
  return enabledApps.has(appName);
}
